import httpManager from "../../shared/utils/httpManager";

export async function validateTokenNewUser(token) {
  const url = "/users/verify-token/";
  return httpManager.post(url, { token }, { isPublic: true });
}
